import { SystemField } from "./system-field";

export class AppMenu extends SystemField { 

     title?:string;
     name?:string;
     icon?:string;
     path?:string;
     class?:string;
     is_external_link?:number;
     is_divider?:number;
     parent_menu_id?:string;
     applications_id?:string;
     ordering?:number;
     is_setting?:number;
     badge?: string;
     badgeClass?: string;
     submenu?: AppMenu[]; 
}
